














import { computed, defineComponent } from '@vue/composition-api'

/**
 * チェックボックスを表示するAtomコンポーネント。
 */
export default defineComponent({
  name: 'AtomInputCheckbox',
  props: {
    /**
     * Value値
     */
    value: {
      type: Boolean,
      required: true,
    },
    /**
     * 非活性にするかどうか
     */
    isDisabled: {
      type: Boolean,
      default: false,
    },
    /**
     * カラーパターン
     */
    color: {
      type: String,
      default: 'light',
    },
  },
  setup(props, context) {
    /**
     * inputValue
     * @param {string} val チェックボックスの値
     */
    const inputValue = computed({
      get: () => props.value,
      set: (val: boolean) => context.emit('input', val),
    })

    return {
      inputValue,
    }
  },
})
